export default __webpack_public_path__ + "static/media/sticker-ch.74f10138.png";